<div class='poam-component' style='height: 100%'>
  <div style="display: flex; flex-direction: row; justify-content: space-between; align-items: start">
    <div>
      <h2 style="font-family: Roboto, 'Helvetica Neue', sans-serif; margin: 10px 10px 10px 10px">Devices</h2>
    </div>

    <div style="display: flex; flex-direction: row; margin-top: 6px;margin-bottom: 10px;align-items:center;">
      <!--button type="button"
              (click)="addActionPlan()"
              pButton
              class="risksponge-button" icon="pi pi-plus"></button-->
    </div>
  </div>
  <p-table [value]="devices"
           [style]="{'margin-top':'10px', 'white-space':'nowrap'}" sortField="deviceId"
           #devicesTable>

    <ng-template pTemplate="header">
      <tr>
        <th>Device Name</th>
        <th>Type</th>
        <th>Manufacturer</th>
        <th>Model</th>
        <th>Serial Number</th>
        <th>IP</th>
        <th>Mac</th>
        <th>Puid</th>
        <th>Owner</th>
        <th>Location</th>
        <th>Monitoring</th>
        <th>CVE</th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-rowIndex="rowIndex" let-item>
      <tr>
        <td>{{ item.deviceName }}</td>
        <td>{{ item.type }}</td>
        <td>{{ item.manufacturer }}</td>
        <td>{{ item.model }}</td>
        <td>{{ item.serialNumber }}</td>
        <td>{{ item.ip }}</td>
        <td>{{ item.mac }}</td>
        <td>{{ item.puid }}</td>
        <td>{{ item.owner }}</td>
        <td>{{ item.location }}</td>
        <td>
          @for (result of item.findings; track result.id) {
            <div class="cursor-pointer underline" (click)="openFindings(result)">{{result.date | date:'shortDate' }}</div>
          }
        </td>
        <td>
          @for (result of item.cveItems; track result.cveId) {
            <div class="cursor-pointer underline"><a target="_blank" [href]="'https://www.cve.org/CVERecord?id=' + result.cveId">{{result.cveId}}</a></div>
          }
        </td>
      </tr>
    </ng-template>

  </p-table>
</div>
